<template>
  <div class="ship-unit-container">
    <h4 class="integrated-shipment-headers">Ship Units</h4>
    <div v-if="orderInfo">
      <div
        class="box-container"
        v-for="(shipUnit, index) in orderInfo.ship_units"
        :key="index"
      >
        <div class="box-header">
          <span>{{ 'Box: ' + (index + 1) }}</span>
          <div class="box-weight-info">
            <button @click="getWeight(shipUnit.id)">Get Wt</button>
            <input
              type="number"
              step=".01"
              max="150"
              :value="shipUnit.weight"
              @input="updateWeight($event, shipUnit.id)"
            />
            <span>
              {{ orderInfo.location.uom_weight }}
              <font-awesome-icon
                v-if="loading === shipUnit.id"
                icon="circle-notch"
                spin
                class="loading-spinner"
              />
            </span>
          </div>
        </div>
        <div class="box-dimensions-container">
          <div class="box-type-input">
            <label>
              Box Type:
              <select
                id="box-type"
                @change="updateBoxType($event, shipUnit.id)"
              >
                <option></option>
                <option
                  v-for="box in orderInfo.box_types"
                  :key="box.id"
                  :value="box.id"
                  :selected="box.name === shipUnit.box_type"
                >
                  {{ box.name }}
                </option>
              </select>
            </label>
          </div>
          <div class="box-inputs">
            <label>
              Length:
              <input
                type="number"
                :value="shipUnit.length"
                @input="updateLength($event, shipUnit.id)"
              />
            </label>
            <label>
              Width:
              <input
                type="number"
                :value="shipUnit.width"
                @input="updateWidth($event, shipUnit.id)"
              />
            </label>
            <label>
              Height:
              <input
                type="number"
                :value="shipUnit.height"
                @input="updateHeight($event, shipUnit.id)"
              />
            </label>
          </div>
        </div>
        <ul class="board-header">
          <li>Item</li>
          <li>Qty</li>
        </ul>
        <Board :id="shipUnit.id" @itemMoved="moveItem">
          <ShipmentItem
            v-for="item in shipUnit.items"
            :key="item.id"
            :id="item.id"
            :box_id="shipUnit.id"
            :draggable="checkSettings()"
          >
            <div class="split-checkbox">
              <input
                v-if="!editing && settings.split_lines"
                type="checkbox"
                :id="item.id"
                :value="item.id"
                @change="selectedItem(shipUnit.id, item.id)"
                :checked="item.id === picked"
              />
              <li>{{ item.item_number }}</li>
            </div>
            <li v-if="item.editable">
              <input
                type="number"
                class="editable-quantity"
                value
                v-model="quantity"
              />
            </li>
            <li v-else>{{ item.quantity }}</li>
          </ShipmentItem>
          <div class="split-line-button-container">
            <button
              v-if="selectedBox === shipUnit.id && !editing"
              @click="addRow(shipUnit.id)"
            >
              Split Line
            </button>
            <button
              v-if="editing && selectedBox === shipUnit.id"
              @click="updateRow(shipUnit.id)"
            >
              Update
            </button>
            <button
              v-if="editing && selectedBox === shipUnit.id"
              @click="cancelUpdate(shipUnit.id)"
            >
              Cancel
            </button>
          </div>
        </Board>
        <span
          class="delete-box-button"
          @click="deleteBox(shipUnit.id)"
          v-if="shipUnit.items.length === 0"
          >Delete Box</span
        >
      </div>
    </div>
    <div class="add-box-container">
      <button
        v-if="orderInfo && settings.create_boxes"
        class="add-box-button"
        @click="addBox"
      >
        Add Box
      </button>
    </div>
    <button
      v-if="
        orderInfo &&
          !emptyDimensions &&
          validInternational &&
          orderInfo.carrier_info.carrier !== '' &&
          orderInfo.carrier_info.service !== '' &&
          (orderInfo.special_items.hold_ship == false ||
            !orderInfo.special_items.hold_ship)
      "
      class="btn btn-primary shipment-button"
      @click="createShipment"
    >
      Ship
      <font-awesome-icon
        v-if="loadingShipment"
        icon="circle-notch"
        spin
        class="loading-spinner"
      />
    </button>

    <button
      v-if="orderInfo"
      class="btn btn-primary save-shipment-button"
      @click="openShippingStateModal"
    >
      Save Delivery
    </button>
  </div>
</template>

<script>
import Board from './board.vue';
import ShipmentItem from './shipmentItem.vue';
export default {
  name: 'shipmentContainer',
  data: function() {
    return {
      picked: null,
      editing: false,
      quantity: 0,
      splittingId: null,
      newId: null,
    };
  },
  components: {
    Board,
    ShipmentItem,
  },
  methods: {
    moveItem(itemId, oldBoxId, newBoxId) {
      this.$emit('itemMoved', itemId, oldBoxId, newBoxId);
    },
    openShippingStateModal() {
      this.$emit('toggleStateModal');
    },
    getWeight(boxId) {
      this.$emit('getWeight', boxId);
    },
    deleteBox(boxId) {
      this.$emit('removeBox', boxId);
    },
    addBox() {
      this.$emit('addBox', this.incrementBoxId());
    },
    updateBoxType(e, boxId) {
      this.$emit('updateBoxType', boxId, e.target.value);
    },
    updateWeight(e, boxId) {
      this.$emit('updatedWeight', e.target.value, boxId);
    },
    createShipment() {
      this.$emit('createShipment');
    },
    checkSettings() {
      return this.settings.consolidate;
    },
    addRow(boxId) {
      const newId = this.createRandomId();
      this.editing = true;
      this.splittingId = this.picked;
      this.newId = newId;
      this.splittingBoxId = boxId;
      this.$emit('addRow', boxId, this.picked, newId);
    },
    cancelUpdate(boxId) {
      this.$emit('cancelUpdate', boxId, this.newId);
      this.editing = false;
      this.picked = null;
      this.newId = null;
      this.splittingId = null;
      this.quantity = 0;
    },
    updateWidth(e, unitId) {
      this.$emit('updateBoxWidth', e.target.value, unitId);
    },
    updateLength(e, unitId) {
      this.$emit('updateBoxLength', e.target.value, unitId);
    },
    updateHeight(e, unitId) {
      this.$emit('updateBoxHeight', e.target.value, unitId);
    },
    updateRow(boxId) {
      this.editing = false;
      this.$emit(
        'updateRow',
        boxId,
        this.splittingId,
        this.newId,
        this.quantity
      );
      this.quantity = 0;
      this.picked = null;
      this.newId = null;
      this.splittingId = null;
    },
    selectedItem(boxId, itemId) {
      if (itemId === this.picked) {
        this.picked = null;
        this.$emit('selectedItem', null);
      } else {
        this.picked = itemId;
        this.$emit('selectedItem', boxId);
      }
    },
    createRandomId() {
      return (
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15)
      );
    },
    incrementBoxId() {
      const regex = /\-(.*)\#/;
      let orderId = this.$props.orderInfo.ship_units[
        this.$props.orderInfo.ship_units.length - 1
      ].id;
      const incremented_id = parseInt(orderId.match(regex)[1]) + 1;
      return orderId.replace(
        regex,
        `-${incremented_id.toString().padStart(3, '0')}#`
      );
    },
    validate_itn() {
      if (
        this.$props.orderInfo.carrier_info.international_value >= 2500 &&
        this.$props.selectedCarrier &&
        this.$props.selectedCarrier.carrier_name == 'FedEx'
      ) {
        return this.$props.orderInfo.carrier_info.international_itn !== '';
      } else return true;
    },
    caseCompare(val1, val2) {
      return val1.toLowerCase() === val2.toLowerCase();
    },
  },
  computed: {
    emptyDimensions: function() {
      return this.$props.orderInfo.ship_units.find((unit) =>
        [unit.length, unit.width, unit.height, unit.weight].includes(0)
      );
    },
    validInternational: function() {
      if (!this.caseCompare(this.$props.orderInfo.ship_to.country, this.$props.orderInfo.ship_from.country)) {
        const carrier_info = this.$props.orderInfo.carrier_info;
        const itn_valid = this.validate_itn();
        return (
          carrier_info.description !== '' &&
          carrier_info.international_value !== 0 &&
          itn_valid
        );
      } else {
        return true;
      }
    },
  },
  props: [
    'orderInfo',
    'selectedBox',
    'loading',
    'loadingShipment',
    'settings',
    'toggleStateModal',
  ],
};
</script>

<style scoped>
.box-weight-info {
  float: right;
  width: 61%;
}

.split-checkbox {
  display: inherit;
  align-items: center;
}

.box-weight-info input {
  width: 46%;
}

.ship-box {
  height: 150px;
  overflow: auto;
  padding: 0.5rem;
}

h4 {
  width: 100%;
  margin: -1rem;
  margin-bottom: 1rem;
}

.box-container {
  position: relative;
  border: 1px solid black;
  background: lightgrey;
  display: inline-block;
  width: 350px;
  min-height: 212px;
  overflow: auto;
  vertical-align: top;
  margin-right: 1rem;
  margin-bottom: 1rem;
}

.editable-quantity {
  width: 36px;
}

.shipment-button {
  position: absolute;
  top: 10px;
  right: 13px;
  width: 111px;
}

.save-shipment-button {
  position: absolute;
  top: 10px;
}

.split-line-button-container {
  position: absolute;
  bottom: 1px;
  width: 100%;
  padding-left: 0.4rem;
  margin-left: -8px;
  background: white;
}

.board {
  padding: 1rem 0.5rem;
  padding-bottom: 2rem;
}

.box-dimensions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5rem;
}

.box-type-input {
  width: 45%;
}

#box-type {
  width: 100%;
}

.box-inputs {
  width: 50%;
  display: flex;
  align-items: center;
}

.delete-box-button {
  width: 50%;
  text-align: center;
  display: block;
  margin: 0 auto;
  cursor: pointer;
  margin-left: -100px;
  bottom: 11px;
  left: 50%;
  position: absolute;
  background: white;
  border-radius: 10px;
  box-shadow: 0px 1px 2px black;
}
.box-inputs label {
  width: 30%;
}

.box-inputs label input {
  width: 65%;
}

.ship-unit-container {
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
  border: 1px solid black;
  height: 48vh;
  overflow: auto;
  padding: 1rem;
  box-sizing: border-box;
  position: relative;
  display: inline-block;
  vertical-align: top;
}

ul {
  margin: 0.5rem 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
}

.add-box-container {
  position: fixed;
  position: sticky;
  bottom: -16px;
  background: white;
  width: 100%;
  padding: 0.5rem;
  margin-top: 1rem;
}

.card {
  background: white;
  padding: 5px;
  cursor: grab;
}

.box-header {
  background: white;
  padding: 0.5rem;
}

.board-header {
  margin-bottom: 0;
  padding: 0 1rem;
}
</style>
